import { render, staticRenderFns } from "./soil_sensor.vue?vue&type=template&id=450f961e&"
import script from "./soil_sensor.vue?vue&type=script&lang=js&"
export * from "./soil_sensor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports